export default "__VITE_ASSET__c569fd7e__"